"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseURI = void 0;
const is_null_1 = require("./is-null");
exports.parseURI = (value) => {
    const matches = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?").exec(value);
    /* istanbul ignore next */
    if (is_null_1.isNull(matches)) {
        return undefined;
    }
    return {
        scheme: matches[2],
        authority: matches[4],
        path: matches[5],
        query: matches[7],
        fragment: matches[9],
    };
};
//# sourceMappingURL=parse-uri.js.map